import React from 'react'
import T from 'prop-types'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import { MuiThemeProvider } from '@material-ui/core/styles'
import IntlProvider from 'components/common/IntlProvider/IntlProvider'
import ErrorBoundary from 'components/error-boundary/ErrorBoundary'
import ScrollToTop from 'components/ScrollToTop'
import lightTheme from 'components/themes/lightTheme'
import Main from './Main'
import RouteWrapper from './RouteWrapper'

function Root({ store, history }) {
  return (
    <MuiThemeProvider theme={lightTheme}>
      <Provider store={store}>
        <IntlProvider>
          <ErrorBoundary>
            <ConnectedRouter store={store} history={history}>
              <ScrollToTop>
                <RouteWrapper path="/" component={Main} />
              </ScrollToTop>
            </ConnectedRouter>
          </ErrorBoundary>
        </IntlProvider>
      </Provider>
    </MuiThemeProvider>
  )
}

Root.propTypes = {
  store: T.object.isRequired,
  history: T.object.isRequired,
}

export default Root
